
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Listings from './pages/Listings';
import PropertyDetail from './pages/PropertyDetail';
import Publish from './pages/Publish';
import Services from './pages/Services';
import About from './pages/About';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';

function App() {
  const location = useLocation();

  // Scroll to top on route change
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-900 bg-gray-light">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nos-biens" element={<Listings />} />
          <Route path="/biens" element={<Listings />} /> {/* Redirect/Alias */}
          <Route path="/bien/:id" element={<PropertyDetail />} />
          <Route path="/publier" element={<Publish />} />
          <Route path="/nos-services" element={<Services />} />
          <Route path="/qui-nous-sommes" element={<About />} />
          <Route path="/mentions-legales" element={<Legal />} />
          <Route path="/confidentialite" element={<Privacy />} />
          <Route path="*" element={<div className="p-20 text-center">Page introuvable</div>} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
